import { Routes, Route } from 'react-router-dom';

import Home from '@/pages/Home';
import CaseIndex from '@/pages/CaseIndex';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import CookiePolicy from '@/pages/CookiePolicy';
import Support from '@/pages/Support';
import PromoModal from '@/components/PromoModal';
import ScrollToTop from '@/components/ScrollToTop';

/**
 * 路由。首页 2026-08 改版为深色「机架」，见 src/pages/Home.tsx；
 * 每个通道的案例页见 src/pages/CaseIndex.tsx（/cases/motion|agent|quant）。
 * 法务与支持页仍是原来的浅色版式，未改动。
 */
function App() {
  return (
    <div className="min-h-screen">
      <PromoModal />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cases/:channel" element={<CaseIndex />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/support" element={<Support />} />
      </Routes>
      <ScrollToTop />
    </div>
  );
}

export default App;
